module.exports = __webpack_public_path__ + "img/activity7.2377ccfc.png";